import BaseModule from '@/store/baseModule';
import BaseModulePlugins from '@/store/baseModule/plugins';
import BaseService from '@/services/services/tools/baseService';
import BaseAPI from '@/services/api/internal/tools/baseAPI';

export default (store) => {
  store.registerModule(
    ['actions', 'gain_types'],
    new BaseModule({
      serviceAPI: new BaseService({
        api: new BaseAPI({
          url: `${process.env.MYPREDITY_BASE_URI}/actions/gain_state/gain_type`,
        }),
        retry: { nbLeft: 3, timeout: 2000 },
      }),
    })
  );
  const basePlugin = new BaseModulePlugins({
    module: 'actions/gain_types',
    store,
  });
  basePlugin.onInit(() => store.dispatch('actions/gain_types/initItems'));
};
